<template>
  <div @click="outsideClick" :class="{ active: show }" class="modalPreview">
    <div v-if="show">
      <div>
        <iframe class="previewModal" :src="url" title="preview"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      show: false,
    }
  },
  computed: {
    modal() {
      return this.$store.getters.modalPreview
    },
    url() {
      return this.modal?.url
    },
  },
  watch: {
    modal() {
      if (this.modal) {
        this.openModal()
      }
    },
  },
  methods: {
    ...mapActions(['modalPreview']),
    openModal() {
      this.show = true
    },

    closeModal() {
      this.show = false
      this.modalPreview(null)
    },
    outsideClick(e) {
      if (e.target === document.querySelector('.modalPreview')) {
        this.closeModal()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modalPreview {
  display: none;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  // z-index: 99998;
  animation: show 0.5s forwards;
  &.active {
    display: flex;
  }
  > div {
    max-width: 1000px;
    position: fixed;
    top: 120px;
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
    @include tipography(16);
    color: $main-two;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // z-index: 999999;
    text-align: center;
    button {
      border: none;
      border-radius: 3px;
      padding: 10px 20px;
      letter-spacing: 3px;
      text-transform: uppercase;
      font-weight: bold;
      cursor: pointer;
      margin-top: 20px;
      @include tipography(15);
      &:focus {
        outline: none;
      }
      &:nth-last-of-type(1) {
        background: $blue;
        margin-left: 15px;
      }
      &:nth-last-of-type(2) {
        color: $gray-2;
        background: $gray-light;
      }
    }
  }
}
.previewModal {
  width: 40vw;
  height: 60vh;
}
@media (max-width: 900px) {
  .previewModal {
    width: 70vw;
    height: 60vh;
  }
}
</style>
